import React from "react";
import { EntityProfileErrorState, EntityProfileLoadingState } from "./EntityProfileFeedback";

type Props = {
  children: React.ReactNode;
  errorLabel: string;
  filters?: React.ReactNode;
  isError: boolean;
  isLoading: boolean;
  loadingLabel: string;
  onRetry?: () => void;
};

export default function EntityProfileQuerySection(props: Props) {
  if (props.isLoading) {
    return (
      <>
        {props.filters}
        <EntityProfileLoadingState label={props.loadingLabel} />
      </>
    );
  }

  if (props.isError) {
    return (
      <>
        {props.filters}
        <EntityProfileErrorState label={props.errorLabel} onRetry={props.onRetry} />
      </>
    );
  }

  return (
    <>
      {props.filters}
      {props.children}
    </>
  );
}
